<template>
  <zcy-layout :show-border="false">
    <template v-slot:default="slotProps">
      <div class="guide-main">
        <div class="guide-header-img">
          <a :href="`${slotProps.envHref && slotProps.envHref.front}/market-manage-index/#/isv/detail`">
            <img src="https://sitecdn.zcycdn.com/zcy-front-other-upload/50350f8e423dec987bfa152656eb159a.png?x-oss-process=image/quality,Q_75/format,jpg" alt=""/>
          </a>
        </div>

        <div class="guide-summary">
          <div class="guide-present">
            <p class="guide-present-title">应用市场简介</p>
            <div class="guide-present-context">
              政采云应用市场，是针对应用软件的在线交易与管理平台，政府采购领域的“App Store”。应用市场旨在汇聚优秀的第三方应用软件开发商，共同为采购单位、供应商和代理机构等政府采购参与方提供信息化解决方案。
            </div>
          </div>

          <div class="guide-advantage-box">
              <div class="guide-advantage">
                  <img src="https://sitecdn.zcycdn.com/zcy-front-other-upload/e9bfdf5666d5a58c0ce8fd60e8fe3f48.png" alt=""/>
                  <div class="guide-advantage-context">
                    <p class="guide-advantage-title">10万+客户单位</p>
                    <p class="guide-advantage-describe">4.6万家采购单位，6.5万家供应商已在平台上活跃交易，客户资源丰富</p>
                  </div>
              </div>
              <div class="guide-advantage">
                  <img src="https://sitecdn.zcycdn.com/zcy-front-other-upload/1fe43babeab274491a12cad3d6b42142.png" alt=""/>
                  <div class="guide-advantage-context">
                    <p class="guide-advantage-title">6省3市广阔市场</p>
                    <p class="guide-advantage-describe">政采云已覆盖浙江全省，广西、重庆等5省（市）及无锡等2个地级市，还有多地正在落地洽谈</p>
                  </div>
              </div>
              <div class="guide-advantage">
                  <img src="https://sitecdn.zcycdn.com/zcy-front-other-upload/026f7a5d55dd5b1b6188f91634553cd8.png" alt=""/>
                  <div class="guide-advantage-context">
                    <p class="guide-advantage-title">超市化交易流程</p>
                    <p class="guide-advantage-describe">软件采购全流程电子化，应用一次上架，全部客户可购买，避免开发商重复投标</p>
                  </div>
              </div>
              <div class="guide-advantage">
                  <img src="https://sitecdn.zcycdn.com/zcy-front-other-upload/ee2443db6a49f014c1d6e261b38ce96e.png" alt=""/>
                  <div class="guide-advantage-context">
                    <p class="guide-advantage-title">打通财政支付渠道</p>
                    <p class="guide-advantage-describe">与国库支付系统无缝对接，可实现从预算管理、采购下单、合同签订、验收备案到支付结算的全流程在线操作</p>
                  </div>
              </div>
          </div>
        </div>

        <div class="register">
          <div class="register-head">
            <p class="register-title">入驻应用市场</p>
            <p class="register-content">同时满足以下3个条件，即可申请入驻</p>
          </div>
          <div class="register-container">
            <div class="register-box">
              <div class="register-box-head lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/6f67945d3d5eeffb3de29643a8f5a199.png?x-oss-process=image/quality,Q_75/format,jpg" alt=""/>
              </div>
              <div class="register-box-content">
                <p>平台正式供应商</p>
              </div>
              <div class="register-no">1</div>
              <div class="register-triangle"></div>
            </div>
            <div class="register-box">
              <div class="register-box-head lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/e54a410f1fbe60dd2a18eb2f0c04facc.png?x-oss-process=image/quality,Q_75/format,jpg" alt=""/>
              </div>
              <div class="register-box-content">
                <p>信用记录良好，没有被“信用中国”等网站列入失信名单</p>
              </div>
              <div class="register-no">2</div>
              <div class="register-triangle"></div>
            </div>
            <div class="register-box">
              <div class="register-box-head lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/92b64411ec2079450879d388a768f5bb.png?x-oss-process=image/quality,Q_75/format,jpg" alt=""/>
              </div>
              <div class="register-box-content">
                <p>具有自行开发的应用软件产品，或拥有软件开发团队</p>
              </div>
              <div class="register-no">3</div>
              <div class="register-triangle"></div>
            </div>
          </div>
        </div>

        <div class="guide-process lazy-img">
            <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/a7daf1a1e5bd8cd76e9bcd419a224a9f.png?x-oss-process=image/quality,Q_75/format,jpg" alt=""/>
        </div>

        <div class="service">
          <div class="service-head">
              <p class="service-head-title">入驻成功后，应用市场能为我提供什么？</p>
              <p class="service-head-content">平台提供全面支持，应用软件可轻松部署销售，应用开发商可专注于产品研发</p>
          </div>
          <div class="service-container">
            <div class="service-box">
              <div class="service-box-icon lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/2b201ea05a921bf8f2d38644d9251632.png" alt=""/>
              </div>
              <div class="service-box-content">
                <p class="service-box-title">应用上架支持</p>
                <p class="service-box-describe">
                  · 应用申请、接入、发布3步上架销售
                  <br />
                  · 应用一次上架，全场通用购买
                </p>
              </div>
            </div>
            <div class="service-box">
              <div class="service-box-icon lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/e2921ad828dd812aa18294ff7f7cf06e.png" alt=""/>
              </div>
              <div class="service-box-content">
                <p class="service-box-title">平台技术支持</p>
                <p class="service-box-describe">
                  · 提供7天*24小时软件license授权验证服务
                  <br />
                  · 平台技术中台能力沉淀赋能开发者
                </p>
              </div>
            </div>
            <div class="service-box">
              <div class="service-box-icon lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/13525ef0edc9a3b8839644a3970699fa.png" alt=""/>
              </div>
              <div class="service-box-content">
                <p class="service-box-title">结算支付支持</p>
                <p class="service-box-describe">
                  · 打通政府财政性资金支付渠道
                  <br />
                  · 提供预算合同备案支付全流程支持
                </p>
              </div>
            </div>
            <div class="service-box">
              <div class="service-box-icon lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/9930edebb9b9453b2ba4fcf7de393d55.png" alt=""/>
              </div>
              <div class="service-box-content">
                <p class="service-box-title">安全可控的云资源</p>
                <p class="service-box-describe">
                  · 平台提供阿里政务云与公有云资源
                  <br />
                  · 开发者可基于云架构开发和部署
                </p>
              </div>
            </div>
            <div class="service-box">
              <div class="service-box-icon lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/24d7ce66ec0fa592d70e1052dd040503.png" alt=""/>
              </div>
              <div class="service-box-content">
                <p class="service-box-title">运维运营与培训支持</p>
                <p class="service-box-describe">
                  · 提供工单系统、智能客服转接服务
                  <br />
                  · 提供培训服务赋能应用开发商
                </p>
              </div>
            </div>
            <div class="service-box">
              <div class="service-box-icon lazy-img">
                <img data-src="https://sitecdn.zcycdn.com/zcy-front-other-upload/5c0d812ea59170d2addb3589782208ab.png" alt=""/>
              </div>
              <div class="service-box-content">
                <p class="service-box-title">推广服务</p>
                <p class="service-box-describe">
                  · 开发商享受资源位推广、用户推荐
                  <br />
                  · 随政采云业务拓展推广产品至省外市场
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="guide-foot-img">
          <p class="foot-img-title">
            <span>入驻应用市场</span>
            <span>交付软件服务</span>
            <span>共创商业未来</span>
          </p>
          <a :href="`${slotProps.envHref && slotProps.envHref.front}/market-manage-index/#/isv/detail`" class="foot-img-check">立即入驻</a>
          <a href="https://www.wjx.top/jq/35443921.aspx" class="foot-img-doubt"  target="_blank">如有疑问，联系我们</a>
        </div>
      </div>
    </template>
  </zcy-layout>
</template>
<script>
import throttle from 'lodash/throttle';
import Layout from '@/components/layout';
import { lazyLoadImg } from '@/utils/lazy';

export default {
  name: 'guide',
  components: {
    'zcy-layout': Layout
  },
  mounted () {
    lazyLoadImg('lazy-img');
    window.addEventListener('scroll', throttle(() => lazyLoadImg('lazy-img'), 100));
  }
};
</script>
<style lang="less">
@import '../../assets/css/common.less';
@header-img-bg: #172471;
@guide-explain-bg: #fff;
@title-color: #404040;
@content-color: #7c7070;
@base-border-radius: 6px;
@title-font-size: 22px;
@content-font-size: 16px;
html,body {
  margin: 0;
  font-family: @family-nomal;
  font-size: @font-size-s;
  color: @font-color-main;
  background: @site-bg-color;
  -webkit-font-smoothing: antialiased;
}
a {
  text-decoration: none;
}
p {
  margin: 0; // 避免默认样式
}
.guide-main {
  display: flex;
  flex-direction: column;
  align-items: center;

  .guide-header-img {
    width: 100%;
    overflow: hidden;
    background-color: @header-img-bg;
    text-align: center;
    img {
      width:1200px;
      height:420px;
      vertical-align:bottom;
    }
  }
  .guide-summary {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 750px;
    width: 100%;
    background: #fff;

    .guide-present {
      width: 680px;
      margin-top: 100px;
      margin-bottom: 80px;

      .guide-present-title {
        font-size: @title-font-size;
        line-height: 29px;
        color: @title-color;
        font-weight: 800;
        text-align: center;
      }

      .guide-present-context {
        margin-top: 20px;
        font-size: 18px;
        line-height: 27px;
        color: @content-color;
        text-align: center;
      }
    }

    .guide-advantage-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      height: 340px;
      width: 1120px;
      margin: 0 auto;
      margin-bottom: 100px;

      .guide-advantage {
        display: flex;
        justify-content: space-between;
        height: 120px;
        width: 520px;

        img {
          height: 120px;
          width: 120px;
          border-radius: @base-border-radius;
        }

        .guide-advantage-context {
          width: 360px;

          .guide-advantage-title {
            font-size: 16px;
            line-height: 21px;
            font-weight: 800;
            color: @title-color;
          }

          .guide-advantage-describe {
            margin-top: 20px;
            font-size: 16px;
            line-height: 21px;
            color: @content-color;
          }
        }
      }
    }
  }
  .register {
    height: 673px;
    margin: 0 auto;
    background-color: #f8f8f8;
    .register-head {
      margin-top: 100px;
      text-align: center;
      .register-title {
        font-size: @title-font-size;
        line-height: 29px;
        color: @title-color;
        font-weight: 800;
      }
      .register-content {
        font-size: 18px;
        color: @content-color;
        line-height: 24px;
        margin-top: 20px;
      }
    }
    .register-container {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      margin-top: 80px;

      .register-box {
        position: relative;
        background: #FFFFFF;
        box-shadow: 0 2px 8px 0 rgba(177,177,177,0.50);
        border-radius: @base-border-radius;
        height: 320px;
        width: 280px;

        .register-box-head {
          img {
            height: 209px;
            width: 280px;
            border-top-left-radius: @base-border-radius;
            border-top-right-radius: @base-border-radius;
          }
        }
        .register-box-content {
          height: 111px;
          p {
            margin-top: 32px;
            margin-left: 30px;
            width: 220px;
            font-size: 16px;
            line-height: 21px;
            font-weight: 400;
            color: @content-color;
          }
        }
        .register-no {
          position: absolute;
          top: 191px;
          left: -8px;
          width: 51px;
          height: 32px;
          background-color: #5987e8;
          line-height: 32px;
          font-weight: 800;
          color: #fff;
          text-align: center;
          font-size: 20px;
        }
        .register-triangle {
          position: absolute;
          top: 223px;
          left: -8px;
          height: 0px;
          width: 0px;
          border-style: solid;
          border-width: 4px 4px 4px 4px;
          border-color: #3865c3 #3865c3 transparent transparent;
        }
      }
    }
  }

  .guide-process {
    width: 100%;
    overflow: hidden;
    background-color: #242251;
    text-align: center;
    img {
      width:1200px;
      height:457px;
      vertical-align:bottom;
    }
  }

  .service {
    height: 913px;
    width: 100%;
    background-color: #fff;
    .service-head {
      text-align: center;
      //margin-top: 100px;

      .service-head-title {
        padding-top: 100px;
        font-size: @title-font-size;
        line-height: 29px;
        color: @title-color;
        font-weight: 800;
      }
      .service-head-content {
        margin-top: 20px;
        font-size: 18px;
        line-height: 29px;
        color: @content-color;
      }
    }

    .service-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0 auto;
      margin-top: 80px;
      width: 1100px;

      .service-box {
        display: flex;
        justify-content: flex-start;
        width: 470px;
        margin-bottom: 100px;

        .service-box-icon img {
          height: 120px;
          width: 120px;
          border-radius: 50%;
        }
        .service-box-content {
          font-size: 16px;
          line-height: 21px;
          margin-left: 40px;
          .service-box-title {
            color: @title-color;
            font-weight: 800;
          }
          .service-box-describe {
            color: @content-color;
            margin-top: 20px;
          }
        }
      }
    }
  }

  .guide-foot-img {
    width: 100%;
    height: 241px;
    overflow: hidden;
    background-color: #242251;
    text-align: center;
    background-image: url(https://sitecdn.zcycdn.com/zcy-front-other-upload/2a4f58acf04b5a36d939e4c7b2c52702.png?x-oss-process=image/quality,Q_75/format,jpg);
    background-size: 1200px 241px;
    .foot-img-title {
      margin-top: 50px;
      font-size: 24px;
      line-height: 33px;
      color: #fff;
    }
    .foot-img-check {
      display: block;
      border-radius: 18px;
      height: 36px;
      width: 158px;
      margin: 0 auto;
      margin-top: 30px;
      background-color: #5987e8;
      font-size: 14px;
      line-height: 36px;
      color: #fff;
      font-weight: 700;
    }
    .foot-img-doubt {
      display: block;
      margin-top: 20px;
      font-size: 16px;
      line-height: 22px;
      color:white;
      // animation: color 1s ease-in-out 0.1s;
      transition: color 0.2s ease-in-out 0s;
      &:hover {
        color: @color-blue;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/guide.vue